import { RiskLevel } from "@portal/types/robot/IRobotEnums";
import { ISavingCalculations } from "@portal/types/robot/ISavingCalculations";

export const MapRiskLevels = (
  riskLevel: RiskLevel | undefined,
  calculations: ISavingCalculations | undefined,
  sustainability: boolean,
) => {
  if (!calculations || riskLevel === undefined) return null;

  if (riskLevel.toString() === RiskLevel[RiskLevel.Careful]) {
    return sustainability ? calculations.sustainableCareful : calculations.careful;
  }

  if (riskLevel.toString() === RiskLevel[RiskLevel.Balanced]) {
    return sustainability ? calculations.sustainableBalanced : calculations.balanced;
  }

  if (riskLevel.toString() === RiskLevel[RiskLevel.Offensive]) {
    return sustainability ? calculations.sustainableOffensive : calculations.offensive;
  }

  if (riskLevel.toString() === RiskLevel[RiskLevel.ExtraOffensive]) {
    return sustainability ? calculations.sustainableExtraOffensive : calculations.extraOffensive;
  }

  return null;
};
